// 2024 Topps Star Wars Chrome Sapphire Edition — The Phantom Menace 25th Anniversary.
// Topps.com online exclusive (on sale May 4, 2024; wide release May 24, 2024). First
// Sapphire built as its own product rather than a reprint of an earlier Chrome set:
// the 100-card base retells Episode I in story order.
// Cards verified against the official Topps sell-sheet checklist (STW2476 V3) and
// TCDB; parallel ladders verified against the official Topps odds sheet
// (2024StarWarsChromeSapphireOdds.pdf, via web.archive.org) — insert ladders differ
// per insert, and Sapphire Selections has no Black Sapphire tier.
// DF-15 "Oppenent" is Topps' own typo, confirmed on the printed card — do not fix.
// Duel of the Fates and Podracing have NO unnumbered version — Green Sapphire /99 is
// the entry tier. The sell sheet also lists a "Mystery Redemption" (checklist never
// published by Topps); intentionally not represented as a card row.

const BASE_P = [
  {id:"purple-sapphire",name:"Purple Sapphire",print_run:125,color:"#cb7dff"},
  {id:"green-sapphire",name:"Green Sapphire",print_run:99,color:"#5fd35f"},
  {id:"yellow-sapphire",name:"Yellow Sapphire",print_run:75,color:"#f5e05a"},
  {id:"gold-sapphire",name:"Gold Sapphire",print_run:50,color:"#f0c040"},
  {id:"orange-sapphire",name:"Orange Sapphire",print_run:25,color:"#ff9d52"},
  {id:"black-sapphire",name:"Black Sapphire",print_run:10,color:"#a8a8b4"},
  {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
  {id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"},
];

// Duel of the Fates & Podracing: numbered tiers only (no unnumbered insert exists).
const NUMBERED_INSERT_P = BASE_P.filter(p => p.id !== "purple-sapphire");

export const SETS = [
  {
    id: "base", type: "base", title: "BASE SET — 100 CARDS",
    parallels: BASE_P,
    cards: [
      {n:"1", name:"The Chancellor's Ambassadors Arrive", artist:null},
      {n:"2", name:"The Trade Federation's Mysterious Conspirator", artist:null},
      {n:"3", name:"The Radiant VII is Obliterated!", artist:null},
      {n:"4", name:"Poisonous Gas Fills the Meeting Room", artist:null},
      {n:"5", name:"A Squad of Droids Arrive", artist:null},
      {n:"6", name:"The Jedi Make Their Way to the Command Deck", artist:null},
      {n:"7", name:"Breaking Down the Blast Doors", artist:null},
      {n:"8", name:"Stowaways", artist:null},
      {n:"9", name:"The Queen's Disapproval", artist:null},
      {n:"10", name:"Senator Sheev Palpatine", artist:null},
      {n:"11", name:"The Trade Federation Touches Down on Naboo", artist:null},
      {n:"12", name:"Hunt for the Jedi", artist:null},
      {n:"13", name:"On the Run in the Swamp!", artist:null},
      {n:"14", name:"Jar Jar Binks", artist:null},
      {n:"15", name:"Seeking Safety Among the Gungans", artist:null},
      {n:"16", name:"The Banished One", artist:null},
      {n:"17", name:"The Hidden Underwater City", artist:null},
      {n:"18", name:"An Unwelcome Return", artist:null},
      {n:"19", name:"Boss Nass", artist:null},
      {n:"20", name:"The Jedi & Their Navigator", artist:null},
      {n:"21", name:"Creatures of the Deep", artist:null},
      {n:"22", name:"The Dark Lord's Political Tactics", artist:null},
      {n:"23", name:"Theed Falls to the Trade Federation Army", artist:null},
      {n:"24", name:"The Royal Court Rescued!", artist:null},
      {n:"25", name:"Boarding the Queen's Starship", artist:null},
      {n:"26", name:"Blasting through the Blockade", artist:null},
      {n:"27", name:"The Heroic Astromech, R2-D2", artist:null},
      {n:"28", name:"Necessary Repairs on Tatooine", artist:null},
      {n:"29", name:"\"He will find your lost ship…\"", artist:null},
      {n:"30", name:"The Queen's Handmaiden, Padmé Amidala", artist:null},
      {n:"31", name:"Watto's Junk Shop", artist:null},
      {n:"32", name:"Meeting Anakin Skywalker", artist:null},
      {n:"33", name:"Negotiating with Watto", artist:null},
      {n:"34", name:"Finding Trouble with the Locals", artist:null},
      {n:"35", name:"Sebulba & Anakin Skywalker", artist:null},
      {n:"36", name:"Shelter in the Skywalker Home", artist:null},
      {n:"37", name:"Anakin's Protocol Droid", artist:null},
      {n:"38", name:"Darth Maul is Sent to Tatooine", artist:null},
      {n:"39", name:"The Podracing Solution", artist:null},
      {n:"40", name:"Making the Deal with Watto", artist:null},
      {n:"41", name:"Anakin's Gifts", artist:null},
      {n:"42", name:"The Prophecy of the Chosen One", artist:null},
      {n:"43", name:"Repairs for Anakin's Podracer", artist:null},
      {n:"44", name:"Blood Sample Analysis", artist:null},
      {n:"45", name:"Dispatching the Seeker Droids", artist:null},
      {n:"46", name:"A New Bet with Watto", artist:null},
      {n:"47", name:"The Boonta Eve Classic", artist:null},
      {n:"48", name:"Qui-Gon Jinn's Advice", artist:null},
      {n:"49", name:"Protests from Padmé", artist:null},
      {n:"50", name:"Moving Through The Field of Racers", artist:null},
      {n:"51", name:"Clash with Sebulba", artist:null},
      {n:"52", name:"Victory!", artist:null},
      {n:"53", name:"\"Now you can make your dreams come true, Ani\"", artist:null},
      {n:"54", name:"Our Heroes Encounter Darth Maul", artist:null},
      {n:"55", name:"A Narrow Escape", artist:null},
      {n:"56", name:"Arrival on Coruscant", artist:null},
      {n:"57", name:"Palpatine's Disdain for Republic Politics", artist:null},
      {n:"58", name:"Qui-Gon Jinn Reports to the Jedi Council", artist:null},
      {n:"59", name:"A Vergence in the Force", artist:null},
      {n:"60", name:"The Queen's Plea to the Senate", artist:null},
      {n:"61", name:"Chancellor Valorum's True Allegiance", artist:null},
      {n:"62", name:"Vote of No Confidence", artist:null},
      {n:"63", name:"The Rebellious Qui-Gon Jinn", artist:null},
      {n:"64", name:"\"Fear is the path to the dark side\"", artist:null},
      {n:"65", name:"Palpatine's Rise to Supreme Chancellor", artist:null},
      {n:"66", name:"Return to Naboo", artist:null},
      {n:"67", name:"The Will of the Force", artist:null},
      {n:"68", name:"Otoh Gunga Deserted", artist:null},
      {n:"69", name:"Imploring the Gungans for Help", artist:null},
      {n:"70", name:"The True Queen Revealed", artist:null},
      {n:"71", name:"Jar Jar Binks' Promotion", artist:null},
      {n:"72", name:"The Plan to Capture the Viceroy", artist:null},
      {n:"73", name:"The Gungans Mobilize", artist:null},
      {n:"74", name:"The Trade Federation Opens Fire", artist:null},
      {n:"75", name:"The Queen's Army Mounts Their Attack!", artist:null},
      {n:"76", name:"Dispatching the Pilots", artist:null},
      {n:"77", name:"Anakin Skywalker's Hiding Spot", artist:null},
      {n:"78", name:"Engaging the Droid Control Ship", artist:null},
      {n:"79", name:"Droids Activated!", artist:null},
      {n:"80", name:"Jedi vs. Sith", artist:null},
      {n:"81", name:"R2-D2 & Anakin Skywalker Join the Battle", artist:null},
      {n:"82", name:"Duel Beneath the Palace", artist:null},
      {n:"83", name:"Swarms of Droid Starships", artist:null},
      {n:"84", name:"Ascending the Palace Walls", artist:null},
      {n:"85", name:"The Gungan Shields Fall", artist:null},
      {n:"86", name:"Crash Landing in the Droid Ship Hangar", artist:null},
      {n:"87", name:"The Queen Captured?", artist:null},
      {n:"88", name:"Obi-Wan Kenobi's Ferocious Fight", artist:null},
      {n:"89", name:"The Main Reactor Fails", artist:null},
      {n:"90", name:"The Droid Army Deactivated", artist:null},
      {n:"91", name:"The Sith Apprentice Defeated!", artist:null},
      {n:"92", name:"Viceroy Apprehended", artist:null},
      {n:"93", name:"\"Peace and prosperity to the Republic\"", artist:null},
      {n:"94", name:"At Odds with Master Yoda", artist:null},
      {n:"95", name:"The Gungans are Surrounded", artist:null},
      {n:"96", name:"The Fate of Anakin Skywalker", artist:null},
      {n:"97", name:"\"Always two there are…\"", artist:null},
      {n:"98", name:"The Gungans Arrive in Theed", artist:null},
      {n:"99", name:"Padawan Anakin Skywalker", artist:null},
      {n:"100", name:"Peace for Naboo", artist:null},
    ]
  },
  {
    id: "duel-of-the-fates", type: "insert", title: "DUEL OF THE FATES — 20 CARDS",
    parallels: NUMBERED_INSERT_P,
    cards: [
      {n:"DF-1", name:"Storming the Palace Hangar", artist:null},
      {n:"DF-2", name:"Enter: Darth Maul!", artist:null},
      {n:"DF-3", name:"Two Jedi Versus One Sith", artist:null},
      {n:"DF-4", name:"Beneath the Palace", artist:null},
      {n:"DF-5", name:"Obi-Wan Kenobi Hangs for Dear Life!", artist:null},
      {n:"DF-6", name:"Qui-Gon Jinn Takes on Darth Maul Alone", artist:null},
      {n:"DF-7", name:"Struggling to Catch Up", artist:null},
      {n:"DF-8", name:"Separated by Laser Gates", artist:null},
      {n:"DF-9", name:"The Intimidating Darth Maul", artist:null},
      {n:"DF-10", name:"A Moment of Calm for Qui-Gon Jinn", artist:null},
      {n:"DF-11", name:"Darth Maul Gains the Upper Hand", artist:null},
      {n:"DF-12", name:"The Sith Waits for the Apprentice", artist:null},
      {n:"DF-13", name:"A Flurry of Attacks from Obi-Wan Kenobi", artist:null},
      {n:"DF-14", name:"Maul's Lightsaber is Cut in Half", artist:null},
      {n:"DF-15", name:"Sending His Oppenent into the Chasm!", artist:null},
      {n:"DF-16", name:"Darth Maul Taunts Obi-Wan Kenobi", artist:null},
      {n:"DF-17", name:"Obi-Wan Kenobi Reemerges!", artist:null},
      {n:"DF-18", name:"Qui-Gon Jinn's Final Request", artist:null},
      {n:"DF-19", name:"Qui-Gon Jinn Advances", artist:null},
      {n:"DF-20", name:"Darth Maul pulls out Dual Lightsaber", artist:null},
    ]
  },
  {
    id: "jedi-high-council", type: "insert", title: "JEDI HIGH COUNCIL — 12 CARDS",
    parallels: [
      {id:"base",name:"",print_run:100,color:"#4d9fff"},
      {id:"orange-sapphire",name:"Orange Sapphire",print_run:25,color:"#ff9d52"},
      {id:"black-sapphire",name:"Black Sapphire",print_run:10,color:"#a8a8b4"},
      {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
      {id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"},
    ],
    cards: [
      {n:"JC-1", name:"Yaddle", artist:null},
      {n:"JC-2", name:"Plo Koon", artist:null},
      {n:"JC-3", name:"Adi Gallia", artist:null},
      {n:"JC-4", name:"Depa Billaba", artist:null},
      {n:"JC-5", name:"Saesee Tiin", artist:null},
      {n:"JC-6", name:"Yarael Poof", artist:null},
      {n:"JC-7", name:"Eeth Koth", artist:null},
      {n:"JC-8", name:"Oppo Rancisis", artist:null},
      {n:"JC-9", name:"Even Piell", artist:null},
      {n:"JC-10", name:"Ki-Adi-Mundi", artist:null},
      {n:"JC-11", name:"Mace Windu", artist:null},
      {n:"JC-12", name:"Yoda", artist:null},
    ]
  },
  {
    id: "podracing", type: "insert", title: "PODRACING — 10 CARDS",
    parallels: NUMBERED_INSERT_P,
    cards: [
      {n:"PR-1", name:"Arriving at the Hangar", artist:null},
      {n:"PR-2", name:"Watto's Chance Cubes", artist:null},
      {n:"PR-3", name:"Sebulba's Interference", artist:null},
      {n:"PR-4", name:"A Tough Start for Anakin Skywalker", artist:null},
      {n:"PR-5", name:"Weaving Through the Other Racers", artist:null},
      {n:"PR-6", name:"Pushed off of the Track by Sebulba!", artist:null},
      {n:"PR-7", name:"Quick Thinking Recovery", artist:null},
      {n:"PR-8", name:"In the Final Stretch!", artist:null},
      {n:"PR-9", name:"Victory for Anakin Skywalker!", artist:null},
      {n:"PR-10", name:"Freed from Watto", artist:null},
    ]
  },
  {
    id: "sapphire-selections", type: "insert", title: "SAPPHIRE SELECTIONS — 20 CARDS",
    parallels: [
      {id:"gold-sapphire",name:"Gold Sapphire",print_run:50,color:"#f0c040"},
      {id:"orange-sapphire",name:"Orange Sapphire",print_run:25,color:"#ff9d52"},
      {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
      {id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"},
    ],
    cards: [
      {n:"SS-1", name:"Qui-Gon Jinn", artist:null},
      {n:"SS-2", name:"Queen Amidala", artist:null},
      {n:"SS-3", name:"R2-D2", artist:null},
      {n:"SS-4", name:"Sabé", artist:null},
      {n:"SS-5", name:"Anakin Skywalker", artist:null},
      {n:"SS-6", name:"Jar Jar Binks", artist:null},
      {n:"SS-7", name:"Mace Windu", artist:null},
      {n:"SS-8", name:"Yoda", artist:null},
      {n:"SS-9", name:"Captain Panaka", artist:null},
      {n:"SS-10", name:"Darth Maul", artist:null},
      {n:"SS-11", name:"Senator Palpatine", artist:null},
      {n:"SS-12", name:"Shmi Skywalker", artist:null},
      {n:"SS-13", name:"Ki-Adi-Mundi", artist:null},
      {n:"SS-14", name:"Sebulba", artist:null},
      {n:"SS-15", name:"Nute Gunray", artist:null},
      {n:"SS-16", name:"Boss Nass", artist:null},
      {n:"SS-17", name:"Sio Bibble", artist:null},
      {n:"SS-18", name:"Chancellor Valorum", artist:null},
      {n:"SS-19", name:"Ric Olié", artist:null},
      {n:"SS-20", name:"Obi-Wan Kenobi", artist:null},
    ]
  },
  {
    id: "phantom-menace-cast-autographs", type: "auto", title: "PHANTOM MENACE CAST AUTOGRAPHS — 13 CARDS",
    parallels: [
      {id:"black-sapphire",name:"Black Sapphire",print_run:10,color:"#a8a8b4"},
      {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
      {id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"},
    ],
    cards: [
      {n:"PA-AB", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"PA-BB", name:"Brian Blessed", artist:"Boss Nass"},
      {n:"PA-EM", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"PA-IM", name:"Ian McDiarmid", artist:"Senator Palpatine"},
      {n:"PA-KK", name:"Keira Knightley", artist:"Sabé"},
      {n:"PA-LM", name:"Lewis MacLeod", artist:"Sebulba"},
      {n:"PA-MC", name:"Michaela Cottrell", artist:"Even Piell"},
      {n:"PA-NP", name:"Natalie Portman", artist:"Queen Amidala"},
      {n:"PA-OD", name:"Oliver Ford Davies", artist:"Sio Bibble"},
      {n:"PA-RB", name:"Ralph Brown", artist:"Ric Olié"},
      {n:"PA-RP", name:"Ray Park", artist:"Darth Maul"},
      {n:"PA-SJ", name:"Samuel L. Jackson", artist:"Mace Windu"},
      {n:"PA-WD", name:"Warwick Davis", artist:"Weazel"},
    ]
  },
  {
    id: "dual-autographs", type: "auto", title: "DUAL AUTOGRAPHS — 3 CARDS",
    parallels: [
      {id:"base",name:"",print_run:5,color:"#4d9fff"},
      {id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"},
    ],
    cards: [
      {n:"PD-MB", name:"Ewan McGregor / Ahmed Best", artist:"Obi-Wan Kenobi / Jar Jar Binks"},
      {n:"PD-PK", name:"Keira Knightley / Natalie Portman", artist:"Sabé / Queen Amidala"},
      {n:"PD-PM", name:"Ray Park / Ian McDiarmid", artist:"Darth Maul / Darth Sidious"},
    ]
  },
  {
    id: "sapphire-selections-autographs", type: "auto", title: "SAPPHIRE SELECTIONS AUTOGRAPHS — 9 CARDS",
    parallels: [
      {id:"red-sapphire",name:"Red Sapphire",print_run:5,color:"#ff5d5d"},
      {id:"padparadscha-sapphire",name:"Padparadscha Sapphire",print_run:1,color:"#ff9e80"},
    ],
    cards: [
      {n:"SSA-AB", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"SSA-BB", name:"Brian Blessed", artist:"Boss Nass"},
      {n:"SSA-EM", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"SSA-IM", name:"Ian McDiarmid", artist:"Senator Palpatine"},
      {n:"SSA-KK", name:"Keira Knightley", artist:"Sabé"},
      {n:"SSA-NP", name:"Natalie Portman", artist:"Queen Amidala"},
      {n:"SSA-OD", name:"Oliver Ford Davies", artist:"Sio Bibble"},
      {n:"SSA-RP", name:"Ray Park", artist:"Darth Maul"},
      {n:"SSA-SJ", name:"Samuel L. Jackson", artist:"Mace Windu"},
    ]
  },
];
